import sysIconsConf from "@/store/sysIconsConf"
import { getRealShipLocationExtent, getRealShipByMmsis } from "@/service/apis"
import { fromLonLat, toLonLat } from "ol/proj";
import { Fill, Icon, Style, Circle as CircleStyle } from "ol/style";
import moment from "moment";
import { getShipByMMsisAuto } from "../../../../service/apis";
import { setFeatureStyle } from "../../../mapUtils/mapIcon";
import { ceateHighLight } from '@/pages/tablePanels/fish/fishMethods/fishLayer'
// 后端设置的请求限制
const ShipLimit = 400
// 地图上最多显示的渔船数量
const maxShipCount = 2000
const limit = 400
// 推进时绿点变为渔船的图层
export function createShipLayer(map, iconHelper, cacheExtentShip, cacheExtentShipList) {
    let { source, layer } = iconHelper.getParams()
    // layer.setZIndex(1000)
    layer.setMinZoom(9)
    let debounce = createDebounce(500)
    map.on("moveend", () => {
        let zoom = map.getView().getZoom()
        if (zoom >= 9) {
            let extent = getExtent(map)
            extent.limit = limit
            // 做节流处理
            debounce(() => {

                getRealShipLocationExtent(extent).then(async (res) => {

                    let { data } = res

                    if (Array.isArray(data) && data.length > 0) {
                        data.filter(ship => !cacheExtentShip.get(ship.mmsi)).forEach(ship => {
                            addShipToShipLayer(ship, cacheExtentShip, cacheExtentShipList, iconHelper)
                        })
                        manageShipLayer(cacheExtentShip, cacheExtentShipList, iconHelper)


                        // 过滤出目前地图上没有的
                        // let mmsis = data.map(v => v.mmsi).filter(mmsi => !cacheExtentShip.get(mmsi));
                        // 测试，先少请求一些
                        // 切割数组满足服务器限制
                        // let promises = sliceArray(mmsis, ShipLimit).map(mmsi => {
                        //     return getRealShipByMmsis({ mmsis: mmsi.join(",") })
                        // })
                        // let res = await Promise.all(promises)
                        // res.forEach(({ data: dt }) => {
                        //     if (Array.isArray(dt) && dt.length > 0) {
                        //         // 清理图层
                        //         // source.clear()
                        //         // 添加图标
                        //         dt.forEach(ship => {
                        //             if (!ship || !ship.mmsi) return
                        //             if (!cacheExtentShip.get(ship.mmsi)) {
                        //                 // 添加渔船到渔船图层
                        //                 addShipToShipLayer(ship, cacheExtentShip, cacheExtentShipList, iconHelper)
                        //             }

                        //         })
                        //     }

                        // })
                        // manageShipLayer(cacheExtentShip, cacheExtentShipList, iconHelper)


                    }
                })
            })
        } else if (zoom < 8) {
            source.clear()
            cacheExtentShip.clear()
        }
    })
}
export function addShipToShipLayer(ship, cacheExtentShip, cacheExtentShipList, iconHelper) {

    cacheExtentShip.set(ship.mmsi, addShipIcon(iconHelper, ship))
    // 缓存
    cacheExtentShipList.push(ship.mmsi)
}
/**
 * 管理渔船图层，删除多余的图标
 * @param {*} cacheExtentShip 
 * @param {*} cacheExtentShipList 
 */
export function manageShipLayer(cacheExtentShip, cacheExtentShipList, iconHelper) {
    // 清除超过长度限制的
    if (cacheExtentShipList.length > maxShipCount) {
        let len = cacheExtentShipList.length - maxShipCount
        let needsToRemove = cacheExtentShipList.slice(0, len)
        needsToRemove.forEach(mmsi => {
            // 清除需要删除的渔船
            let feature = cacheExtentShip.get(mmsi)
            let { removeIcon } = iconHelper
            if (feature) {

                removeIcon(feature)
                cacheExtentShip.delete(mmsi)
            }
        })
        cacheExtentShipList.splice(0, len)
    }
}
/**
 * 将数组切割成不超过count的小数组
 * @param {Array<any>} arr 
 * @param {number} count 
 */
export function sliceArray(arr, count) {
    if (arr.length < count) return [arr]
    let res = []
    let p = 0

    while (p < arr.length - count) {
        res.push(arr.slice(p, p + count))
        p += count
    }
    res.push(arr.slice(p))
    return res
}
/**
 * 将渔船包裹成合理的业务对象并添加到iconHelper 控制的图层
 * @param {boolean} isRealInfo 是不是真的信息，有时撒点还没查询真实的mmsi，只是简单的用于撒点的信息，这是先做个标记，后面点击的更新更新
 */
export async function addShipIcon(iconHelper, ship, isRealInfo = true) {
    let { addIcon } = iconHelper
    // 使用火星坐标
    let { gc_lng, gc_lat, lng, lat, lon } = ship;
    lon = gc_lng || lng || lon
    lat = gc_lat || lat
    let { normalStyle, highStyle } = await createShipStyle(ship)
    let basicFeature = addIcon(fromLonLat([lon, lat]), {}, "ship", ship)
    basicFeature.setStyle(normalStyle)
    basicFeature.set("styles", { normalStyle, highStyle })
    // 代表渔船是否调用了mmsi接口获取信息
    basicFeature.set("updated", isRealInfo)
    basicFeature.set("isWebgl", false)


    return basicFeature
}
export function addWebglShipIcon(iconHelper, ship, isRealInfo = true) {
    let { addIcon } = iconHelper
    // 使用火星坐标
    let { gc_lng, gc_lat, lng, lat, lon } = ship;
    lon = gc_lng || lng || lon
    lat = gc_lat || lat
    let basicFeature = addIcon(fromLonLat([lon, lat]), {}, "ship", ship)
    let { normalStyle, highStyle } = createWebglShipStyle(ship)
    // basicFeature.setStyle(normalStyle)
    basicFeature.set("styles", { normalStyle, highStyle })
    // 代表渔船是否调用了mmsi接口获取信息
    basicFeature.set("updated", isRealInfo)
    basicFeature.set("isWebgl", true)
    setFeatureStyle(basicFeature, normalStyle)


    return basicFeature
}
/**
 * 检查并更新渔船信息
 */
export function checkAndUpdateShip(shipFeatures) {
    if (!Array.isArray(shipFeatures)) {
        shipFeatures = [shipFeatures]
    }
    let filterdShips = shipFeatures.filter(ship => ship && !ship.get("updated"))
    let shipFeatureMap = new Map()
    let mmsis = []
    filterdShips.forEach(ship => {
        let info = ship.get("info")
        // 添加mmsi
        if (info.mmsi) {
            mmsis.push(info.mmsi)
            shipFeatureMap.set(info.mmsi + "", ship)
        }
    })

    return getShipByMMsisAuto(mmsis).then(({ data }) => {
        if (Array.isArray(data)) {
            data.forEach(ship => {
                let feature = shipFeatureMap.get(ship.mmsi)
                if (feature) {

                    feature.set("info", ship)
                    feature.set("updated", true)
                }
            })
        }
    })
}
//防抖
export function createDebounce(interval) {
    let isInit = true
    let lastTime = new Date().getTime()
    return (func) => {
        let now = new Date().getTime()
        // 初始化的时候可以执行
        if (isInit) {
            isInit = false
            func()
            lastTime = now
            return
        }
        if (now - lastTime > interval) {
            func();
            lastTime = now;
        }

    }
}
/**
 * 获取地图当前范围
 * @param {*} map 
 * @returns 
 */
function getExtent(map) {
    let [slon, slat, elon, elat] = map.getView().calculateExtent();
    [slon, slat] = toLonLat([slon, slat]);
    [elon, elat] = toLonLat([elon, elat]);
    return { slon, slat, elon, elat }


}
/**
 * 创建渔船style
 * @param {*} ship 
 * @returns 
 */
export async function createShipStyle(ship) {
    let dir = ship.dir
    if (Math.abs(dir) > 360) {
        dir = dir / 10

    }
    let shipdir = (dir * Math.PI / 180) || (Math.random() * Math.PI * 2)
    let normalStyle = new Style({
        image: new Icon({
            src: sysIconsConf.SHIPICON_N,
            anchor: [0.5, 0.5],
            rotation: shipdir,
        })
        //     new CircleStyle({
        //     radius: 10,
        //     fill: new Fill({
        //         color: "red"
        //     }),
        // })
    })
    let highSrc = await ceateHighLight(sysIconsConf.SHIPICON_V, { length: 20, strokeWidth: 3, pdx: 20, pdy: 20 })
    let highStyle = new Style({
        image: new Icon({
            // src: sysIconsConf.SHIPICON_V,
            img: highSrc,
            imgSize: [highSrc.width, highSrc.height],
            anchor: [0.5, 0.5],
            rotation: shipdir
        })
    })
    return { normalStyle, highStyle }
}
export function createWebglShipStyle(ship) {
    let shipdir = (ship.dir * Math.PI / 180) || (Math.random() * Math.PI * 2)
    let normalStyle = {
        size: 24,
        rotation: shipdir,
        color: {
            r: 255,
            g: 158,
            b: 7,
            a: 1
        },
        high: 0,

        rotateWithView: true,
    }
    let highStyle = {
        size: 24,
        rotation: shipdir,
        color: {
            r: 255,
            g: 40,
            b: 7,
            a: 1
        },
        high: 1,
        rotateWithView: true,
    }
    return { normalStyle, highStyle }
}
/**
 * 将渔船数据转换为中水系统的渔船对象
 * @param {*} ship 
 * @returns 
 */
export function transformShip(ship) {
    return {
        mmsi: getShipMMSI(ship),
        imo: "--",
        time: ship.dataTime ? moment(ship.dataTime).format("YYYY-MM-DD HH:mm:ss") : "--",
        callNumber: "--",
        lon: ship.lng || ship.lon || 0,
        lat: ship.lat || 0,
        status: ship.status || "--",
        speed: ship.speed || 0,
        rate: "--",
        direction: ship.dir || 0,
        heading: "--",
        name: ship.shipNameCN || ship.nameCn || ship.shipNameEN || ship.name || "--",
        ename: ship.name || "--",
        shipType: ship.shipType || ship.vesselTypeCn || ship.shipType || ship.ctype || "--",
        shipDraftDepth: "--",
        shipLength: (ship.shipLen || ship.shipLength || 0 + "") || "--",
        shipWidth: ship.shipWidth || "--",
        destinationPort: "--",
        countryName: ship.country || ship.countryName || "--",
        companyName: ship.companyName || ship.company || "--",
        areaName: ship.country || ship.countryName || ship.area || "其他",
        company: ship.company || "其他公司",
    }
}

/**
 * 隔几个取一个，让数组变稀疏
 * @param {Array<any>} arr 
 * @param {number} gap 
 */
export function sparseArray(arr, gap) {
    if (gap < 1.5) return arr
    let p = 0;
    let sparse = []
    while (p < arr.length) {
        sparse.push(arr[Math.round(p)])
        p += gap;
    }
    return sparse
}
// 用于在某个地方缓存一个函数，然后在其他地方运行
const _funcMap = new Map()
export function cacheFunc(fn, func) {
    _funcMap.set(fn, func)
}
/**
 * 执行缓存的函数，执行完毕后删除
 * @param {*} fn 函数名
 * @param {*} param 参数，一般不需要
 */
export function callFunc(fn, param) {
    let func = _funcMap.get(fn)
    deleteFunc(fn)
    try {
        if (typeof func == "function") {
            func(param)
        }
    } catch (error) {
        console.error("运行出错", error)
    } finally {

    }

}
export function deleteFunc(fn) {
    _funcMap.delete(fn)

}


// 针对多个接口参数名不同的情况
export function getShipMMSI(ship) {
    if (!ship) return ""
    return (ship.shipMMSI || ship.mmsi || "") + ""
}
export function getShipName(ship) {
    if (!ship) return ""
    return (ship.nameCn || ship.name || "") + ""
}
/**
 * 将数组按照某种元素扁平化,并去除非基本元素
 * @param {*} arr 数组
 * @param {*} func 判断这是否是基本元素
 */
export function flattenBy(arr, func = v => !Array.isArray(v)) {
    let res = []
    arr.forEach((item) => {
        if (func(item)) {
            res.push(item)
        } else if (Array.isArray(item)) {
            flattenBy(item, func).forEach(v => {
                res.push(v)
            })
        }
    })
    return res;
}
// 用于上方的函数，判断是否是基本的多边形
export function isBasicPoly(arr) {
    return Array.isArray(arr) && arr.every(item => Array.isArray(item) && item.length == 2 && item.every(v => typeof v == "number"))
}




// WEBPACK FOOTER //
// ./src/pages/tablePanels/ship/shipMethods/shipLayer.js